import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContractPartnerCompanyForm, ContractPartnerCompanyModel } from '../../new-contract-partner.utils';
import { CustomValidators } from '@shared-ikp/utils/validators';

export function buildOrganizationForm(formBuilder: FormBuilder, model?: ContractPartnerCompanyModel): FormGroup {
  return formBuilder.group<ContractPartnerCompanyForm>({
    name: formBuilder.control(model?.name || '', [Validators.required, CustomValidators.companyNameValidator]),
    birthDate: formBuilder.control(model?.birthDate || null, [CustomValidators.optionalBirthdateValidator]),
    uidNumber: formBuilder.control(model?.uidNumber || '', [Validators.required, CustomValidators.uidValidator]),
    firmenbuchNumber: formBuilder.control(model?.firmenbuchNumber || '', [CustomValidators.optionalFirmenbuchNrValidator]),
    email: formBuilder.control(model?.email || '', [Validators.required, CustomValidators.emailValidator]),
    phone: formBuilder.control(model?.phone || '', [CustomValidators.optionalPhoneNumberValidator]),
  });
}
